import axios from "axios";
import { baseURL } from "./config.js";
import qs from "qs";
//日活统计页面
export default {
  getrihuo(params) {
    const url = baseURL + "/tbClientLogCensus/userCountByDay";
    return axios.post(url, qs.stringify(params));
  },
  getPageLoad(params) {
    const url = baseURL + "/enterprise/loadRatio/pageLoad";
    return axios.post(url, qs.stringify(params));
  },
  getPageLoad2(params) {
    const url = baseURL + "/enterprise/loadRatio/pageLoadPage";
    return axios.post(url, qs.stringify(params));
  },
  getmoduleintegral(params) {
    const url = baseURL + "/tbClientLogModule/listBYmoduleAndLog";
    return axios.post(url, qs.stringify(params));
  },
  getTbModule(params) {
    const url = baseURL + "/tbModule/list";
    return axios.post(url, qs.stringify(params));
  },
  getTbModuleDetails(params) {
    const url = baseURL + "/tbClientLogCmd/listBYmoduleCmdAndLog";
    return axios.post(url, qs.stringify(params));
  },
  getModuleUser(params) {
    const url = baseURL + "/tbClientLog/getUserPointWithModByLog";
    return axios.post(url, qs.stringify(params));
  },
  getMarketPictureCount(params) {
    const url = baseURL + "/enterprise/loadRatio/marketPictureCount";
    return axios.post(url, qs.stringify(params));
  },
  getMarketPictureMap(params) {
    const url = baseURL + "/enterprise/loadRatio/marketPictureMap";
    return axios.post(url, qs.stringify(params));
  },
  getIntegralStatis(params) {
    const url = baseURL + "/enterprise/loadRatio/IntegralStatistics";
    return axios.post(url, qs.stringify(params));
  },
  getintegraDetail(params) {
    const url = baseURL + "/enterprise/loadRatio/histogramStatistics";
    params.city = encodeURI(JSON.stringify(params.city));
    // console.log(params)
    return axios.post(url, qs.stringify(params));
  },
  getUserPointExcel() {
    const url = baseURL + "/tbClientLog/getUserPointWithModByLogExcel";
    return url;
  },
  //返回数据导出的连接
  exportListdata() {
    const url = baseURL + "/enterprise/loadRatio/exportDoc";
    return url;
  },
  //模块积分统计外层返回
  exportmokuaiwai() {
    const url = baseURL + "/tbClientLogModule/listBYmoduleAndLogExcel";
    return url;
  },
  //模块积分列表
  exportmodellist() {
    const url = baseURL + "/tbClientLogCmd/listBYmoduleCmdAndLogExcel";
    return url;
  },
  //销售挂图导出Excel
  exportMarke() {
    const url = baseURL + "/enterprise/loadRatio/exportMarket";
    return url;
  },

  //企业负载 正式客户数和试用客户数
  loadRateSum(params) {
    const url = baseURL + "/enterprise/loadRatio/loadRateSum";
    return axios.post(url, qs.stringify(params));
  },

  //公司客户统计 排名
  loadRatio(params) {
    const url = baseURL + "/enterprise/loadRatio/rankingOrg";
    return axios.post(url, qs.stringify(params));
  },

  // 公司客户统计 个人
  rankingUser(params) {
    const url = baseURL + "/enterprise/loadRatio/rankingUser";
    return axios.post(url, qs.stringify(params));
  },

  //僵尸用户列表
  zombieUser(params) {
    const url = baseURL + "/tbUser/MonthLive";
    return axios.post(url, qs.stringify(params));
  },

  //销售挂图统计图-拜访客户数统计
  marketStatisticsCustomer(params) {
    const url = baseURL + "/enterprise/loadRatio/marketStatisticsCustomer?dateType=" + params.dateType + '&date=' + params.date + '&year=' + params.year;
    return axios.get(url);
  },

  //销售挂图统计图-客户拜访次数统计
  marketStatisticsCount(params) {
    const url = baseURL + "/enterprise/loadRatio/marketStatisticsCount?dateType=" + params.dateType + '&date=' + params.date + '&year=' + params.year;
    return axios.get(url);
  },

  //用户统计-用户统计饼图(status 试用:2 正式：3 
  userStatisticsPie(params) {
    const url = baseURL + "/tbUser/userStatisticsPie?managerAdminuser=" + params.managerAdminuser + '&status=' + params.status + '&type=' + params.type;
    return axios.get(url);
  },

  //用户统计-用户统计数量变化柱状统计图 
  userStatisticsLine(params) {
    const url = baseURL + "/tbUser/userStatisticsLine?managerAdminuser=" + params.managerAdminuser + '&type=' + params.type;
    return axios.get(url);
  },

  //用户统计-用户统计数量累计变化折线统计图 
  userStatisticsLineSum(params) {
    const url = baseURL + "/tbUser/userStatisticsLineSum?managerAdminuser=" + params.managerAdminuser + '&type=' + params.type;
    return axios.get(url);
  },
  // 获取制定人员指定模块命令积分列表
  getUserPointWithCmdByLog(params) {
    const url = baseURL + "/tbClientLog/getUserPointWithCmdByLog?userid=" + params.userid + '&moduleid=' + params.moduleid + '&dBegin=' + params.dBegin + '&dEnd=' + params.dEnd + '&listType=' + params.listType + '&pageNumber=' + params.pageNumber + '&pageSize=' + params.pageSize;
    return axios.get(url);
  },


};



// WEBPACK FOOTER //
// ./src/api/dailyStatistics.js